import { encryptText, storage } from "@/utils";

export default function userTypeReducer(state: string = 'ee', action: any) {
    // console.log('触发设置userType', action)
    let newState = state
    switch (action.type) {
        case 'ee':
            newState = 'ee'
            // storage.setItem('irpas_userType', newState)
            encryptText('irpas_userType', newState)
            return newState
        case 'er':
            newState = 'er'
            // storage.setItem('irpas_userType', newState)
            encryptText('irpas_userType', newState)
            return newState
    }
    // console.log('dispatch执行结束', state)
    return newState
}